module.exports = __webpack_public_path__ + "static/img/5.873a302.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/3/sp/5.png
// module id = 2VJe
// module chunks = 0